export const industryTypes = [
  {
    value: 'Accommodation and Food Services',
    label: 'Accommodation and Food Services',
  },
  {
    value: 'Agriculture, Forestry, Fishing and Hunting',
    label: 'Agriculture, Forestry, Fishing and Hunting',
  },
  {
    value: 'Arts, Entertainment, and Recreation',
    label: 'Arts, Entertainment, and Recreation',
  },
  {
    value: 'Construction',
    label: 'Construction',
  },
  {
    value: 'Ag',
    label: 'Ag',
  },
  {
    value: 'Landscaping',
    label: 'Landscaping',
  },
  {
    value: 'Equipment Rental',
    label: 'Equipment Rental',
  },
  {
    value: 'Oil and Gas',
    label: 'Oil and Gas',
  },
  {
    value: 'Mining and Quarrying',
    label: 'Mining and Quarrying',
  },
  {
    value: 'Material Handling',
    label: 'Material Handling',
  },
  {
    value: 'Educational Services',
    label: 'Educational Services',
  },
  {
    value: 'Finance and Insurance',
    label: 'Finance and Insurance',
  },
  {
    value: 'Physician',
    label: 'Physician',
  },
  {
    value: 'Dentist, Orthodontist',
    label: 'Dentist, Orthodontist',
  },
  {
    value: 'Vet',
    label: 'Vet',
  },
  {
    value: 'Optometrist',
    label: 'Optometrist',
  },
  {
    value: 'Podiatrist',
    label: 'Podiatrist',
  },
  {
    value: 'Other: General',
    label: 'Other: General',
  },
  {
    value: 'Hospital',
    label: 'Hospital',
  },
  {
    value: 'Medical Laboratory',
    label: 'Medical Laboratory',
  },
  {
    value: 'Information',
    label: 'Information',
  },
  {
    value: 'Management of Companies and Enterprises',
    label: 'Management of Companies and Enterprises',
  },
  {
    value: 'Manufacturing',
    label: 'Manufacturing',
  },
  {
    value: 'Mining',
    label: 'Mining',
  },
  {
    value: 'Other Services (except Public Administration)',
    label: 'Other Services (except Public Administration)',
  },
  {
    value: 'Professional, Scientific, and Technical Services',
    label: 'Professional, Scientific, and Technical Services',
  },
  {
    value: 'Public Administration',
    label: 'Public Administration',
  },
  {
    value: 'Real Estate Rental and Leasing',
    label: 'Real Estate Rental and Leasing',
  },
  {
    value: 'Retail Trade',
    label: 'Retail Trade',
  },
  {
    value: 'Local Haul',
    label: 'Local Haul',
  },
  {
    value: 'Warehousing',
    label: 'Warehousing',
  },
  {
    value: 'Refuse Haul',
    label: 'Refuse Haul',
  },
  {
    value: 'Long Haul',
    label: 'Long Haul',
  },
  {
    value: 'Delivery',
    label: 'Delivery',
  },
  {
    value: 'Moving',
    label: 'Moving',
  },
  {
    value: 'Utilities',
    label: 'Utilities',
  },
  {
    value: 'Administrative and Support and Waste Management and Remediation Services',
    label: 'Administrative and Support and Waste Management and Remediation Services',
  },
  {
    value: 'Wholesale Trade',
    label: 'Wholesale Trade',
  },
];

export const termsAndConditions =
  'By signing above and submitting this Application, each individually and as the duly authorized representative of the business-applicant (i) that all information provided in this Application is true, correct and complete, (ii) that the property leased or any credit extended by Trnsact, Inc will be used solely for business and commercial purposes and (iii) that Trnsact is authorized to email information about financing, promotions, and other offers to the email address listed above. The business-applicant and each owner, officer or guarantor listed above further authorize Trnsact or its successors, assigns or one or more alternate third-party funding providers to investigate its organizational and personal credit histories, including, but not limited to, obtaining a credit report from a credit reporting agency, from time to time and for any lawful purposes. Upon the request of an individual owner, officer or guarantor, Trnsact will advise the individual if Trnsact obtained a credit report and Trnsact will give the individual the credit bureau’s name and address. The business applicant and each owner, officer or guarantor listed above direct any creditor or financial institution having any information relating to the business or individual to release such information to Trnsact in connection with this Application. Please see our Privacy Policy, which is available at https://www.dealercreditresources.com/privacy/ for a description of how Trnsact may use and disclose information we collect, as well as certain rights you may have with respect to your information that we collect. By signing this Application, the business-applicant and each owner, officer or guarantor listed above direct Trnsact to disclose or otherwise transmit any and all information and documents that Trnsact may obtain, including, without limitation, business or personal credit reports, this Application and (ifapplicable) any “personal information” under, and as defined in, the California Consumer Privacy Act or under similar applicable laws (howsoever personal information or data may be defined thereunder), to other persons that are involved in or participate with Trnsact in providing commercial funding and the services relatedthereto (including, but not limited to, one or more alternate third-party funding providers, Trnsact’s funding sources, and its and their third-party service providers), in each case for the purposes of facilitating funding for the business-applicant, the on-going facilitation of any funded transaction and for any other purposes set forth in the Privacy Policy. Applicant may opt out of having their credit reports reviewed in consideration for account review, at any time, by contacting Trnsact at support@trnsact.com.';

export const amountConfig = {
  type: 'amount-field',
  config: {
    fieldName: 'amountRequested',
    displayLabel: { en: 'Amount Requested', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Amount Requested',
    variant: 'standard',
    fullWidth: false,
    required: true,
    disabled: false,
    minValue: 500,
    maxValue: 10000000,
    errorMessage: { en: '', es: '' },
  },
  id: '23a41330-d364-4ee8-b6d3-c48f3c7ce978',
};

export const applyingSelect = {
  type: 'select-field',
  config: {
    fieldName: 'applyingSelect',
    displayLabel: { en: 'What are you applying for?', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'What are you applying for?',
    fullWidth: true,
    required: true,
    disabled: false,
    fieldOptions: [
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Both',
        optionValue: 'both',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Credit Line',
        optionValue: 'creditLine',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Equipment Financing',
        optionValue: 'equipmentFinancing',
      },
    ],
  },
  id: '406dnf1b-9175-43b8-9907-c3a72380095e',
};

export const creditLineAmountRequested = {
  type: 'amount-field',
  config: {
    fieldName: 'creditLineAmountRequested',
    displayLabel: { en: 'Credit Line', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Credit Line',
    variant: 'standard',
    fullWidth: false,
    required: true,
    disabled: false,
    minValue: 500,
    maxValue: 10000000,
    dependency: true,
    errorMessage: { en: '', es: '' },
  },
  id: '23a41330-d364-4ee8-b6d3-c48f3c7ce978',
};

export const equipmentFinancing = {
  type: 'amount-field',
  config: {
    fieldName: 'amountRequested',
    displayLabel: { en: 'Equipment Financing', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Equipment Financing',
    variant: 'standard',
    fullWidth: false,
    required: true,
    disabled: false,
    minValue: 500,
    maxValue: 10000000,
    dependency: true,
    errorMessage: { en: '', es: '' },
  },
  id: '23a41330-d364-4ee8-v6d3-c48f3c1ce978',
};

export const phoneConfig = {
  type: 'phone-field',
  config: {
    fieldName: 'ownerPhone',
    displayLabel: { en: 'Phone', es: 'Telefono' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Phone',
    fullWidth: true,
    required: true,
    disabled: false,
    errorMessage: { en: '', es: '' },
  },
  id: 'e534aa45-2d21-4615-bd58-179774399e87',
};

export const emailConfig = {
  type: 'email-field',
  config: {
    fieldName: 'ownerEmail',
    displayLabel: { en: 'Email', es: 'Correo Electronico' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Email',
    fullWidth: true,
    required: true,
    disabled: false,
    errorMessage: { en: '', es: '' },
  },
  id: 'c14840f3-a1db-4e88-ba56-92674a4d262b',
};

export const driversLicenseNum = {
  type: 'text-field',
  config: {
    fieldName: 'driversLicenseNum',
    displayLabel: { en: "Driver's License Number", es: 'Numero de Licencia De Conducir' },
    helperText: { en: '', es: '' },
    fieldLabel: "Driver's License Number",
    fullWidth: true,
    required: true,
    disabled: false,
  },
  id: '8cccf25f-3985-494c-9b6e-b797266a7ceb',
};

export const documentDownload = {
  type: 'image-field',
  config: {
    fieldName: 'image-field',
    displayLabel: { en: 'Download file', es: 'Descargar Archivo' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Download file',
    required: false,
  },
  id: 'd498fd92-cfe5-403f-832a-b8a729e87dca',
};

export const grossMonthlyIncome = {
  type: 'amount-field',
  config: {
    fieldName: 'grossMonthlyIncome',
    displayLabel: { en: 'Gross Monthly Income', es: 'Ingresos Brutos Mensuales' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Gross Monthly Income',
    variant: 'standard',
    fullWidth: false,
    required: false,
    disabled: false,
    minValue: 500,
    maxValue: 10000000,
    errorMessage: { en: '', es: '' },
  },
  id: '23a41330-d664-4ee8-r6d3-c48f3c7ce978',
};

export const homePhone = {
  type: 'phone-field',
  config: {
    fieldName: 'homePhone',
    displayLabel: { en: 'Phone', es: 'Telefono' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Phone',
    fullWidth: true,
    required: true,
    disabled: false,
    errorMessage: { en: '', es: '' },
  },
  id: '55203922-5a9d-42a9-916e-f8cc12dc4b56',
};

export const cellHomePhone = {
  type: 'phone-field',
  config: {
    fieldName: 'cellHomePhone',
    displayLabel: { en: 'Cell Phone Home', es: 'Telefono Celular' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Cell Phone Home',
    fullWidth: true,
    required: true,
    disabled: false,
    errorMessage: { en: '', es: '' },
  },
  id: '552rb922-5a9d-42a9-916e-f8cc12dc4b56',
};

export const homeType = {
  type: 'select-field',
  config: {
    fieldName: 'homeType',
    displayLabel: { en: 'Home Type', es: 'Tipo de Hogar' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Home Type',
    fullWidth: true,
    required: true,
    disabled: false,
    fieldOptions: [
      {
        displayLabel: { en: 'Rent', es: 'Rentado' },
        optionLabel: 'Rent',
        optionValue: 'Rent',
      },
      {
        displayLabel: { en: 'Own', es: 'Propietario' },
        optionLabel: 'Own',
        optionValue: 'Own',
      },
    ],
  },
  id: '406dbf8b-9175-43b8-9907-c3a72380095e',
};

export const timeAtAddressYears = {
  type: 'text-field',
  config: {
    fieldName: 'timeAtAddressYears',
    displayLabel: { en: 'Time At Address (Years)', es: 'Tiempo en el domicilio (Años)' },
    fieldLabel: 'Time At Address (Years)',
    helperText: { en: '', es: '' },
    fullWidth: true,
    required: true,
    disabled: false,
  },
  id: '8cccf25f-3941-494c-9b6e-b797266a7ceb',
};

export const timeAtAddressMonths = {
  type: 'text-field',
  config: {
    fieldName: 'timeAtAddressMonths',
    displayLabel: { en: 'Time At Address (Months)', es: 'Tiempo en el domicilio (Meses)' },
    fieldLabel: 'Time At Address (Months)',
    helperText: { en: '', es: '' },
    fullWidth: true,
    required: true,
    disabled: false,
  },
  id: '8cccf25f-3985-474c-9b6e-b797269g7ceb',
};

export const homeEmail = {
  type: 'email-field',
  config: {
    fieldName: 'emailOwner',
    displayLabel: { en: 'Email', es: 'Correo Electronico' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Email',
    fullWidth: true,
    required: true,
    disabled: false,
    errorMessage: { en: '', es: '' },
  },
  id: 'fbc476a7-e216-40fa-9176-f5b0487c2800',
};

export const ownerSelect = {
  type: 'select-field',
  config: {
    fieldName: 'isOwner',
    displayLabel: { en: 'Are you an Owner or Officer?', es: '' },
    fieldLabel: 'Are you an Owner or Officer?',
    helperText: { en: '', es: '' },
    fullWidth: true,
    required: true,
    disabled: false,
    fieldOptions: [
      {
        displayLabel: { en: 'Yes', es: 'Si' },
        optionLabel: 'Yes',
        optionValue: 'Yes',
      },
      {
        displayLabel: { en: 'No', es: 'No' },
        optionLabel: 'No',
        optionValue: 'No',
      },
    ],
  },
  id: '1638b495-e059-479f-824d-49b6e8a9cb1c',
};

export const ssnExempt = {
  type: 'radio-field',
  config: {
    variants: [
      {
        value: 'Yes',
        label: 'Yes',
      },
      {
        value: 'No',
        label: 'No',
      },
    ],
    fieldName: 'ssnExempt',
    displayLabel: { en: '', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Radio Question',
    required: false,
  },
  id: '0689b42e-06d0-4e3d-92d0-546ed9611e6d',
};

export const uploadDocuments = {
  type: 'image-field',
  config: {
    fieldName: 'image-field',
    displayLabel: { en: '', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Upload Documents',
    required: false,
  },
  id: 'd498fd92-cfe5-603f-812a-b8a729e87dca',
};

export const documentType = {
  type: 'text-field',
  config: {
    fieldName: 'documentType',
    displayLabel: { en: '', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Type here your document type',
    fullWidth: true,
    required: true,
    disabled: false,
  },
  id: '8sscf75f-3985-494c-9b6e-b797266a7ceb',
};

export const applyingBehalf = {
  type: 'select-field',
  config: {
    fieldName: 'applyingBehalf',
    displayLabel: { en: '', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Are you applying on a behalf of a business?',
    fullWidth: true,
    required: true,
    disabled: false,
    fieldOptions: [
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Yes',
        optionValue: 'Yes',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'No',
        optionValue: 'No',
      },
    ],
  },
  id: '4638e445-e059-479f-824d-45b618a9cb1c',
};

export const ownerOperator = {
  type: 'select-field',
  config: {
    fieldName: 'isOwner',
    displayLabel: { en: '', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Are you an owner/operator or sole proprietor?\n',
    fullWidth: true,
    required: true,
    disabled: false,
    fieldOptions: [
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Yes',
        optionValue: 'Yes',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'No',
        optionValue: 'No',
      },
    ],
  },
  id: '1638b495-e059-479f-824d-49b6e1a9cb1c',
};

export const manualBusType = {
  type: 'text-field',
  config: {
    fieldName: 'industryType',
    displayLabel: { en: '', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Type here your industry type',
    fullWidth: true,
    required: true,
    disabled: false,
  },
  id: '8sscf75f-3935-494c-9g68-b797266a7ceb',
};

export const optionBusType = {
  type: 'select-field',
  config: {
    fieldName: 'industryType',
    displayLabel: { en: '', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Industry Type',
    fullWidth: true,
    required: true,
    disabled: false,
    fieldOptions: [
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Accommodation and Food Services',
        optionValue: 'Accommodation and Food Services',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Agriculture, Forestry, Fishing and Hunting',
        optionValue: 'Agriculture, Forestry, Fishing and Hunting',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Arts, Entertainment, and Recreation',
        optionValue: 'Arts, Entertainment, and Recreation',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Construction',
        optionValue: 'Construction',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Ag',
        optionValue: 'Ag',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Landscaping',
        optionValue: 'Landscaping',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Equipment Rental',
        optionValue: 'Equipment Rental',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Oil and Gas',
        optionValue: 'Oil and Gas',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Mining and Quarrying',
        optionValue: 'Mining and Quarrying',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Material Handling',
        optionValue: 'Material Handling',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Educational Services',
        optionValue: 'Educational Services',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Finance and Insurance',
        optionValue: 'Finance and Insurance',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Physician',
        optionValue: 'Physician',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Dentist, Orthodontist',
        optionValue: 'Dentist, Orthodontist',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Vet',
        optionValue: 'Vet',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Optometrist',
        optionValue: 'Optometrist',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Podiatrist',
        optionValue: 'Podiatrist',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Other: General',
        optionValue: 'Other: General',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Hospital',
        optionValue: 'Hospital',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Medical Laboratory',
        optionValue: 'Medical Laboratory',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Information',
        optionValue: 'Information',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Management of Companies and Enterprises',
        optionValue: 'Management of Companies and Enterprises',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Manufacturing',
        optionValue: 'Manufacturing',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Mining',
        optionValue: 'Mining',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Other Services (except Public Administration)',
        optionValue: 'Other Services (except Public Administration)',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Professional, Scientific, and Technical Services',
        optionValue: 'Professional, Scientific, and Technical Services',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Public Administration',
        optionValue: 'Public Administration',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Real Estate Rental and Leasing',
        optionValue: 'Real Estate Rental and Leasing',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Retail Trade',
        optionValue: 'Retail Trade',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Local Haul',
        optionValue: 'Local Haul',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Warehousing',
        optionValue: 'Warehousing',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Refuse Haul',
        optionValue: 'Refuse Haul',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Long Haul',
        optionValue: 'Long Haul',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Delivery',
        optionValue: 'Delivery',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Moving',
        optionValue: 'Moving',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Utilities',
        optionValue: 'Utilities',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Administrative and Support and Waste Management and Remediation Services',
        optionValue: 'Administrative and Support and Waste Management and Remediation Services',
      },
      {
        displayLabel: { en: '', es: '' },
        optionLabel: 'Wholesale Trade',
        optionValue: 'Wholesale Trade',
      },
    ],
  },
  id: 'dc0e9167-c0e1-4120-be5d-4a3fa868aec8',
};

export const equipmentNumInFleet = {
  type: 'amount-field',
  config: {
    fieldName: 'equipmentNumInFleet',
    displayLabel: {
      en: 'Number of Pieces of Equipment in Fleet (If Applicable)',
      es: 'Number of Pieces of Equipment in Fleet (If Applicable)',
    },
    helperText: { en: '', es: '' },
    fieldLabel: 'Number of Pieces of Equipment in Fleet (If Applicable)',
    fullWidth: true,
    required: false,
    disabled: false,
    minValue: 500,
    maxValue: 10000000,
    errorMessage: { en: '', es: '' },
  },
  id: '891a323f-b478-40f3-9ea9-4734540a1787',
};
export const contractorLicenseNum = {
  type: 'text-field',
  config: {
    fieldName: 'contractorLicenseNum',
    displayLabel: { en: 'Contractor License # (if available)', es: 'Contractor License # (if available)' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Contractor License # (if available)',
    fullWidth: true,
    required: false,
    disabled: false,
  },
  id: '49396fb3-3a97-4033-aa9f-80cfc6b80380',
};

export const pastExperience = {
  type: 'text-field',
  config: {
    fieldName: 'pastExperience',
    displayLabel: { en: '', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'If yes, List in Detail',
    fullWidth: true,
    required: false,
    disabled: false,
    dependency: true,
  },
  id: '49396fb3-3a97-4033-aa9f-82cfc6b80380',
};

export const numOfEmployees = {
  type: 'text-field',
  config: {
    fieldName: 'numOfEmployees',
    displayLabel: { en: 'Number Of Employees', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Number Of Employees',
    fullWidth: true,
    required: true,
    disabled: false,
  },
  id: '49396fb3-6a87-4033-aa9f-80cfc6b80380',
};

export const netWorth = {
  type: 'amount-field',
  config: {
    fieldName: 'netWorth',
    displayLabel: { en: '', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Net Worth',
    fullWidth: true,
    required: false,
    disabled: false,
    minValue: 500,
    maxValue: 10000000,
    errorMessage: { en: '', es: '' },
  },
  id: '151a323f-b478-40f3-9ea9-4734540a1787',
};

export const monthlyHousingPayment = {
  type: 'amount-field',
  config: {
    fieldName: 'monthlyHousingPayment',
    displayLabel: { en: '', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'Monthly Housing Payment',
    fullWidth: true,
    required: false,
    disabled: false,
    minValue: 500,
    maxValue: 10000000,
    errorMessage: { en: '', es: '' },
  },
  id: '151a423f-b178-40f3-9ea9-4734540a1787',
};

export const radioQuestion = {
  id: '7fe2a502-0581-4c1e-be7c-774e532cfee4',
  type: 'radio-question',
  config: {
    required: false,
    disabled: false,
    displayed: true,
    columns: 12,
    valuesList: [
      {
        label: 'yes',
        value: 'yes',
      },
      {
        label: 'no',
        value: 'no',
      },
    ],
    fieldName: 'ssnExempt',
    displayLabel: { en: '', es: '' },
    helperText: { en: '', es: '' },
    fieldLabel: 'quickQuestion',
  },
};
